import { useState } from 'react';
import { Button } from '../../../../ui/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../../../../ui/components/ui/dialog';
import { OfferCorrectionPreviewResponseDto } from '../../types/response';

export interface OfferCorrectionDialogProps {
  /** `null` closes the dialog. */
  preview: OfferCorrectionPreviewResponseDto | null;
  mail: string;
  onClose: () => void;
  /** Resolves `true` when the dialog may close. */
  onConfirm: () => Promise<boolean>;
}

/** The change mail exactly as it goes out – the last check before the correction is saved. */
const OfferCorrectionDialog = ({ preview, mail, onClose, onConfirm }: OfferCorrectionDialogProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleConfirm = async () => {
    setIsSubmitting(true);
    try {
      if (await onConfirm()) onClose();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={!!preview} onOpenChange={(open) => !open && !isSubmitting && onClose()}>
      <DialogContent className="flex max-h-[90vh] w-[720px] max-w-[95vw] flex-col bg-white">
        <DialogHeader>
          <DialogTitle className="text-[22px] font-bold text-[#12282A]">Änderungen prüfen</DialogTitle>
          <DialogDescription className="text-[14px] text-[#888]">
            {preview?.hasChanges ? (
              <>
                Diese Mail geht an <span className="font-bold text-[#12282A]">{mail}</span> und intern an Buchhaltung und Info. Geänderte Zeilen sind
                hervorgehoben.
              </>
            ) : (
              'An den Vertragsdaten in der Mail ändert sich nichts – es wird ohne Mail gespeichert.'
            )}
          </DialogDescription>
        </DialogHeader>
        {preview?.hasChanges && (
          // No scripts, no same origin – the mail only has to be looked at.
          <iframe
            title="Vorschau der Änderungsmail"
            sandbox=""
            srcDoc={preview.mailHtml}
            className="min-h-[50vh] w-full flex-1 rounded-xl border border-[#E4E7EC]"
          />
        )}
        <DialogFooter className="flex gap-3">
          <Button variant="outline" onClick={onClose} disabled={isSubmitting}>
            Zurück zum Formular
          </Button>
          <Button onClick={handleConfirm} disabled={isSubmitting}>
            {preview?.hasChanges ? 'Speichern & Mail senden' : 'Speichern'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default OfferCorrectionDialog;
